import { store } from '@/store/store'

store.dispatch('incrustado/codigoPromocion', window.codigoPromocion)
store.dispatch('incrustado/codigoActivo', window.codigoActivo)
store.dispatch('incrustado/numOportunidad', window.numOportunidad)
store.dispatch('incrustado/datosContacto', window.datosContacto)
store.dispatch('incrustado/usuarioComercial', window.usuarioComercial)
if (window.idiomas) {
  // store.dispatch('login/setIdiomas', {
  //   idiomas: window.idiomas,
  //   idiomaDefecto: window.idioma_defecto
  // })
}



// WEBPACK FOOTER //
// ./src/plugins/entorno.js